import React, { Component } from "react";
import { translate } from 'react-i18next';
import Notifications, {notify} from 'react-notify-toast';
import swal from 'sweetalert';
import moment from 'moment';
import {AsyncTypeahead, Typeahead} from 'react-bootstrap-typeahead';
import MaskedFormControl from 'react-bootstrap-maskedinput';
import {Table} from 'react-bootstrap';
import {Link} from 'react-router-dom';

import TableOffers from './components/TableOffers';

import SvgIcon from 'react-icons-kit';
import {home} from 'react-icons-kit/icomoon/home';
import {user} from 'react-icons-kit/icomoon/user';
import {phone} from 'react-icons-kit/icomoon/phone';
import {search} from 'react-icons-kit/icomoon/search';
import {filePdf} from 'react-icons-kit/icomoon/filePdf';
import {profile} from 'react-icons-kit/icomoon/profile';

import ModalPersonSearch from '../generics/modal_person_search';
import ModalDetailsExtraction from './modalDetailsExtraction';
import ModalDetailPatient from './modalDetailPatient';
import ModalTraceability from './modalTraceability';
import ModalUserTraceability from './userTraceability';
import ModalDetails from './modalDetails';

import RaisedButton from 'material-ui/RaisedButton';

import {pencilSquareO} from 'react-icons-kit/fa/pencilSquareO';
import {history} from 'react-icons-kit/icomoon/history';
import {print} from 'react-icons-kit/fa/print';

//import ModalNotes from '../results_donation/components/ModalNotes';
import ModalNotes from './modalNotes';
import Help from '../generics/help';
import { eye } from "react-icons-kit/icomoon/eye";
import $ from 'jquery';
import isEmail from 'validator/lib/isEmail';
import ModalGeneralTraceability from "../generics/modalGeneralTraceability";

const {htmlToText} = require('html-to-text');

var Config = require('../../config');
class SearchDonor extends Component {
  	constructor(props, context) {
	    super(props);
	    this.getInfo = this.getInfo.bind(this);
	    this.updateStateDonor = this.updateStateDonor.bind(this);
	    this.getUsrLLam = this.getUsrLLam.bind(this);
	    this.handleChange = this.handleChange.bind(this);
	    this.phoneChange = this.phoneChange.bind(this);
	    this.onSave = this.onSave.bind(this);
	    this.showNotes = this.showNotes.bind(this);
	    this.openModalNotes = this.openModalNotes.bind(this);
	    this.setTable = this.setTable.bind(this);
	    this.printCarnetDocument = this.printCarnetDocument.bind(this);
	    this.onReturn = this.onReturn.bind(this);
	    this.person_search = this.person_search.bind(this);
	    this.print = this.print.bind(this);
		this.openDetails = this.openDetails.bind(this);
		this.openGeneralTraceability = this.openGeneralTraceability.bind(this);

	    this.state = {
	    	optionsDonor:[],
	    	isLoading: false,
	    	offers:{},
	    	don_usr_llam:{},
	    	filterText:"",

	    	photo:"",
	    	names:"",
			lastname1:"",
			lastname2:"",
			sex:"",
			civil_status:"",
			scholarship:"",
			job_profile:"",
			email:"",
			birthday:"",
			street:"",
			postal_code:"",
			mpio:"",
			state:"",
			person_donor_id:"",
			address_id:"",
			donor_id:"",
			donor_number:"",
			document_type:"",
			document_number:"",
			age:"",
			
			stats:{
				lookup_group:"",
				lookup_rh:"",
				group_test:"",
				status_bar_color:"",
				temporality:"",
			},

			documents:[],
			scholarships:[],
			civil_status_array:[],
			jobProfiles:[],
			requestedSelected:[],
			indice:-1,
			options:[],
			states:[],
			state:"",
			indice_mpio:-1,
			phonesAdded:[],
			tbl_don:[],
			fenotipo_donante:"",
			antibody_donante:"",
			edit:false,
			dataEdition:false,
			du:"",
			notes:[],
			sections:0,
			flag_notes:false,
			flag_alert:false,
			prev_state:{},
			error_email:""
	    };

  	}

  	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
  		$(document).on('blur', '.input-date', (e)=>{
			var date = moment(e.target.value, 'DD/MM/YYYY').format('YYYY-MM-DD');
			
			if(e.target.value !== ""){
				if(date === 'Invalid date' || date === 'Fecha inválida'){
					swal('Error', 'Debes ingresar un valor válido. El campo está incompleto o contiene una fecha no válida.', 'error');

					$('#'+e.target.id).addClass('error');

					setTimeout(()=>{
						$('#'+e.target.id).val('');
						e.target.value = "";
						
						this.dateHandleChange(e);
					}, 3500)
				}else{
					$('#'+e.target.id).removeClass('error');
				}
			}else{
				$('#'+e.target.id).removeClass('error');
			}
		});
  		if(this.props.location.state !== undefined){
  			this.setState({
  				prev_state:this.props.location.state
  			});
  		}


		this.props.socket.onerror = (event)=> {
			console.log(event);
		};

		this.props.socket.onmessage = (event) => {
		    var res = JSON.parse(event.data);
		    if(res.Error !== undefined){
		    	swal('¡Error!', res.Error, 'error');
		    }
		    console.log(res);
		}

  		fetch(Config.default.apiGateway.URL+'lookups?type=document_type&notrender=0',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      documents: response
		    });
		})

		//llamada a servicio de escolaridad
		fetch(Config.default.apiGateway.URL+'lookups?type=SCHOOLING&option=actives&order=false',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      scholarships: response
		    });
		})

		fetch(Config.default.apiGateway.URL+'lookups?type=CIVIL_STATUS&option=actives&order=false',{ 
		    method: 'get',
		    headers: new Headers({
		       	'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       	'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
		  	this.setState({
		      civil_status_array: response
		    });
		})

		fetch(Config.default.apiGateway.URL+'lookups?type=profession&option=actives&order=false',{ 
		    method: 'get',
		    headers: new Headers({
		       	'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       	'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
		  	this.setState({
		      jobProfiles: response
		    });

		})	

		fetch(Config.default.apiGateway.URL+'lookups_level2?type=state_mx&option=parents',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      states: response
		    });
		})


		if(this.props.match.params.donation_id !== undefined){
			this.getInfo(this.props.match.params.donation_id);
		}
  	}

  	_handleSearchDonor = (query) => {
	    if(query !== undefined){
	    	this.setState({isLoading: true});

			fetch(Config.default.apiGateway.URL+'donors?search='+query,{ 
			    method: 'get',
			    headers: new Headers({
			       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			       'Accept': 'application/json',
			       'Content-Type': 'application/json',
			    })
			})
			.then(response => response.json())
			.then(response => {
				if(response !== null){
					for (var i = 0; i < response.length; i++) {
						if(response[i].lastname2 !== undefined && response[i].lastname2 !== null && response[i].lastname2 !== ""){
							response[i].names = response[i].lastname1 +' '+ response[i].lastname2+' '+response[i].names +' '+ 
												(response[i].birthday !== null ? response[i].birthday : "");
						
						}else{
							response[i].names = response[i].lastname1 +' '+ response[i].names +' '+ 
												(response[i].birthday !== null ? response[i].birthday : "");
						}

						if(response[i].document_type_value !== null){							
							response[i].names +=' '+response[i].document_type_value;
						}
						if(response[i].document_number !== null){							
							response[i].names +=' '+response[i].document_number;
						}
						response[i].id = response[i].donor_id;
					};
					
					this.setState({
						isLoading: false,
				      	optionsDonor: response
				    });
				}
			})
	    }
		    
	}

	updateStateDonor(values) {
	    let value = '';
	    if (values.length > 0) {
	      value = values[0];
	    }

	    //this.props.autocompleteHandle('blockFields',true);
		//this.props.getInfo(value.id);
		this.refs._handleSearchDonor._instance.getInstance().clear();
	    this.getInfo(value.id);
	}

  	handleChange(e){
    	
    	if(e.target.name === 'dataEdition'){
    		this.setState({
	      		[e.target.name]: e.target.checked ? true : false,
	    	});
    	}else if(e.target.name === 'birthday'){
    		this.setState({
	      		[e.target.name]: e.target.value
	    	});

	    	this.calcularEdad(e.target.value, 'birthday');
    	}else if(e.target.name === 'email'){
    		this.setState({
	      		[e.target.name]: e.target.value
	    	});


    		if(!isEmail(e.target.value)){
				this.setState({error_email: e.target.value !== "" ? 'Formato no valido' : ""});
			}else{
				this.setState({error_email: ''});
			}
    	}
    	else{
    		this.setState({
	      		[e.target.name]: e.target.value
	    	});
    	}
  	}

  	getInfo(id){
  		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'donors?option=loadDonor&donor_id='+id,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		
		}).then(response => {
			if(response !== undefined){
				this.setInfoDonor(response);

				this.props.waiting.handleClose();
			}
				
		})	
	}

	getfenotipoAntibody(id, campo){
		var url = "";

		switch(campo){
			case 'fenotipo_donante':
				url = 'phenotypes/by_person?person_id='+id+'&type=phenotype';
				break;
			case 'antibody_donante':
				url = 'phenotypes/by_person?person_id='+id+'&type=antibody';
				break;
		}

		fetch(Config.default.apiGateway.URL+url, {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept' 		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		})
		.then(res => {
			if(res.ok){
			  return res.json();
			}else{
			  res.text().then(function(error) {
				swal('¡Error', error, 'error');
			  });
			}
		})
		.then(response =>{
			if(response !== undefined){
				var fenotipo = "";

				switch(campo){
					
					case 'fenotipo_donante':
						response.map((f)=>{
							fenotipo += f.phenotype1+f.result+',  '
						})
						break;
					case 'antibody_donante':
						response.map((f)=>{
							return f.result === "1" ?
								fenotipo += f.antibody+',  '
							: null
						})
						break;
				}

				this.setState({[campo]:fenotipo})
			}
		})
	}

	concatGroupRH(){
		var res = "";

		if(this.state.stats.lookup_rh==="POSITIVO"){
			res = this.state.stats.lookup_group+'+'
		}else if(this.state.stats.lookup_rh==="NEGATIVO"){
			res = this.state.stats.lookup_group+'-';
		}


		return res;
	}

	setInfoDonor(item){
		if(item !== "" && item !== null && item!== undefined){
			if(item.person.photo !== null && item.person.photo !==undefined){
				this.setState({photo:'data:image/jpeg;base64,'+item.person.photo});
			}else{
				this.setState({photo:""});
			}
			var aux_date = new Date(item.person.birthday);
			var string_date = ("0" + aux_date.getDate()).slice(-2)+'/'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'/'+aux_date.getFullYear();

			this.setState({
				names:item.person.names,
				lastname1:item.person.lastname1,
				lastname2:item.person.lastname2!==null?item.person.lastname2:"",
				sex:item.person.sex,
				civil_status:item.person.civil_status,
				scholarship:item.person.scholarship,
				job_profile:item.person.job_profile,
				email:item.person.email,
				birthday:string_date,
				original_birth:string_date,
				street:item.address.street,
				postal_code:item.address.postal_code,
				mpio:item.address.municipio,
				state:item.address.estado,
				person_donor_id:item.person.id,
				address_id:item.address.id,
				donor_id:item.donor.id,
				donor_number:item.donor.donor_number,
				
				stats:{
					lookup_group:item.person.lookup_group,
					lookup_rh:item.person.lookup_rh,
					group_test:item.offer.group_test,
					status_bar_color:item.status_bar_color,
					temporality:item.temporality,
					lectina: item.person.lookup_lectin
				},
				du:item.du,

				edit:true,
				address_id:item.address.id,
				flag_notes:item.flag_notes
			});

			this.getfenotipoAntibody(item.person.id, 'fenotipo_donante');
			this.getfenotipoAntibody(item.person.id, 'antibody_donante');

			this.setTable(item.donor.id);
			
			if(item.document.document !== null){
				this.setState({
					document_type:item.document.document.document_type,
					document_number:item.document.document.document_number
				});
			}
			this.calcularEdad(string_date,'birthday');
			this.setJobProfile(item.person.job_profile);

			this.setState({indice_mpio:0, state:item.address.estado})
			
			this.setMpio(item.address.municipio);
		
			

			this.setState({phonesAdded:[], isLoading: false,});

			if(item.phones !== undefined){
				this.setState({
					phonesAdded: item.phones
				})
			}

			if(item.alerts.length > 0){
				var alerts = "";
				item.alerts.map((n)=>{
					var note = htmlToText(n);
					alerts += note;
				})

				swal('Alerta', alerts, 'warning')
				this.setState({flag_alert:true});
			}

			if(item.notes.length > 0){
				this.setState({notes: item.notes});
			}

			
		}else{
			//this.setState({stats:{}});
		}
	}

	setJobProfile(profile){
    	for (var i = 0; i < this.state.jobProfiles.length; i++) {
			if (this.state.jobProfiles[i].key === profile) {
				this.setState({
					indice:i,
					requestedSelected: [this.state.jobProfiles[i]],
				});
				break;
			}
		}	
    }

	getUsrLLam(){    
	    fetch(Config.default.apiGateway.URL+'functional_criterion?code=don_usr_llam&x=',{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	           'Content-Type': 'application/json',
	        })
	    })
	    .then(response => response.json())
	    .then(response => {
	      this.setState({
	          don_usr_llam: response
	        });
	    })
	} 

	setMpio = (query) => {
  		this.setState({mpioSelected:[]});

	    this.setState({isLoading: true});
		fetch(Config.default.apiGateway.URL+'lookups_level2?type='+query+'&option=municipios',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			if(response !== undefined && response !== null){
				if(response.length > 0){
					for (var i = 0; i < response.length; i++) {
						response[i].names = response[i].municpio.value_name +', '+response[i].estado.value_name;
						response[i].id = i;
					};
					this.setState({
						isLoading: false,
				      	options: response
				    });

				    if (response.length > 1) {
				    	this.setState({
							indice_mpio:-1
					    });
				    }else {
				    	this.setState({mpioSelected:response})
				    };

				}
			}
				
				
		})
	}

	calcularEdad(fecha,control){
		var hoy = new Date();
	    var cumpleanos = new Date(fecha.split(/\//).reverse().join('/'));
	    if(cumpleanos.toString() !== 'Invalid Date'){
		    var edad = hoy.getFullYear() - cumpleanos.getFullYear();
		    var m = hoy.getMonth() - cumpleanos.getMonth();

		    if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
		        edad--;
		    }
		    if(edad >= 0 && edad < 110){
		    	this.setState({age:edad});	
		    }else{
		    	this.setState({age:'', birthday:this.state.original_birth});
		    	this.calcularEdad(this.state.original_birth, 'birthday');
		    	swal('Error', 'Fecha de nacimiento incorrecta', 'error');
		    }
		}
	}

	setTable(id){
		this.props.waiting.handleShow('Cargando...');
		//fetch(Config.default.apiGateway.URL+'offers/by_donor?donor_id='+id+
		//	'&health_facilities_id='+sessionStorage.getItem('health_facilities_id'),{ 
		fetch(Config.default.apiGateway.URL+'offers/by_donor?donor_id='+id+
			'&health_facilities_id='+sessionStorage.getItem('health_facilities_id'),{
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		}).then(res =>{
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({tbl_don:response});
			}
		})
	}

	openPDF(offer){
		//***  /offers_id/donor_id
		if(this.props.match.params.donation_id !== undefined){
			this.props.history.push({
				pathname: '/clinic_history/'+offer.id+'/'+this.state.donor_id,
				state: { 
				    from: '/search_donor'
				}
			})
		}else{
			this.props.history.push({
				pathname: '/clinic_history/'+offer.id+'/'+this.state.donor_id,
				state: { 
				    from: this.props.location.pathname
				}
			});
		}
			
	}

	directPrint(response){
		//PRINTER
		var reader = new FileReader();
		reader.readAsDataURL(response); 
		reader.onloadend = () =>{
			var base64data = reader.result;  
			var aux = base64data.split(',');
			this.props.socket.send('{"Operacion":"print", "Type":"clinic_history", "File": "'+aux[1]+'"}');
		}
	}

	openDefailsExtraction(e, donor, offer, ex){
		e.preventDefault();

		this.modal_extraction.handleShow(donor, offer, ex);
	}

	openDefailsPatient(e, id){
		e.preventDefault();

		this.modal_patient.handleShow(id);
	}

	handleTypeAheadChange = name => values => {
        if(values.length > 0){
        	this.setState({
				indice:0,
				requestedSelected:values,
		    });
        	this.autocompleteHandle(name,values[0].key);
        	
        }else if(this.state.requestedSelected.length > 0){
        	this.setState({
        		requestedSelected:[]
        	});
        }
	}

	autocompleteHandle = (name,value) => {
		this.setState({[name]:value});
	}

	updateState = (values,index) =>{
		if(values!== undefined){
			if(values.length>0){
				this.autocompleteHandle('mpio',values[0].municpio.key);
				this.autocompleteHandle('state',values[0].estado.key);
				this.setState({indice_mpio:values[0].id,mpioSelected:values})
			}
		}

	};

	phoneChange(e, i){
		this.state.phonesAdded[i].number = e.target.value;
		this.forceUpdate();
	}

	onSave(){
		var obj = {
			person:{
				id:this.state.person_donor_id,
				job_profile:null,//this.state.job_profile,
				scholarship:this.state.scholarship,
				birthday:moment(this.state.birthday, 'DD/MM/YYYY').format('MM-DD-YYYY'),
				civil_status:this.state.civil_status,
				sex:this.state.sex,
				email:this.state.error_email !== "" ? "" :this.state.email,
				lastname1:this.state.lastname1, 
				lastname2:this.state.lastname2, 
				names:this.state.names,
				documents:[], 
				phones:this.state.phonesAdded,
				address:{}
			}
		}

		if(this.state.document_type !== ""){
			var docs= {}
			docs.document_type = this.state.document_type;
			docs.document_number = this.state.document_number;
			obj.person.documents = [docs];
		}

		var address = {};

		address.street = this.state.street;
		address.postal_code = this.state.postal_code;
		address.municipio = this.state.mpio;
		address.estado = this.state.state;
		address.id = this.state.address_id;
		
		obj.person.address = address;

		/*if(this.state.error_email !== ""){
			swal('Error', 'Correo electrónico no tiene un formato correcto', 'error');
			return false;
		}*/


		this.props.waiting.handleShow('Guardando...');
		fetch(Config.default.apiGateway.URL+'donors/'+this.state.donor_id,{
			method:'PUT',
			body: JSON.stringify(obj),
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return 'ok'
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				swal('Correcto', 'Los datos se actualizaron correctamente.', 'success');
			}
		})
	}

	openTraceability(e, unit){
		e.preventDefault();
		this.modal_traceability.handleShow(unit);
	}

	openResultsDon(e, sample, donation){
		e.preventDefault();
		this.props.history.push('/results_donation/edit/search/'+sample+'/'+donation+'/0/')
	}

	showNotes(e){
		e.preventDefault();
		this.modal_notes.handleShow(this.state.notes);
	}

	openModalNotes(e){
		this.modal_notes.handleShow(this.state.donor_id);
		
		
	}

	userTraceability(e, id){
		e.preventDefault();

		this.modal_user_traceability.handleShow(id);
	}

	openGeneralTraceability(e){
		e.preventDefault();

		this.modal_general_traceability.handleShow(this.state.person_donor_id, 'donor');
	}
	async printCarnetDocument(e){
		e.preventDefault();
		this.props.waiting.handleShow('Imprimiendo...');
					 
		 var obj ={};
		 obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		 obj.id = this.state.donor_id;
		 obj.file_type = 'donor_card';
		 obj.nEtiqueta = [0];

		 var type = await this.props.getDocumentType(obj.file_type);

		 var document;
		 if(type.print_type === 'template'){
			document = await this.props.printDocumentTemplate(obj, type.print_automatically);
		 }else if(type.print_type === 'external'){
			document = await this.props.printDocumentExternal(obj, type.print_automatically);
		 }

		 if(document !== undefined){
			this.props.waiting.handleClose();
			this.setState({ show: false});
		 }else{
			this.props.waiting.handleClose();
		}
		 
	}

	onReturn(){
		this.props.history.push({
			pathname: this.state.prev_state.from,
			state: { 
			    start: this.state.prev_state.start,
			    end: this.state.prev_state.end
			}
		});
	}

	person_search(){
		this.modal_person_search.handleShow('Donador','donors');
	}

	async print(e, id){
		e.preventDefault();
		
		this.props.waiting.handleShow('Imprimiendo...');
			
		var obj ={};
		obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		obj.id = id;
		obj.file_type = "epidemi_monitoring";
		obj.nEtiqueta = [0];

		var type = await this.props.getDocumentType(obj.file_type);

		var document;
		if(type.print_type === 'template'){
			document = await this.props.printDocumentTemplate(obj, type.print_automatically);
		}else if(type.print_type === 'external'){
			document = await this.props.printDocumentExternal(obj, type.print_automatically);
		}

		if(document !== undefined){
			this.props.waiting.handleClose();
			this.setState({ show: false});
		}else{
			this.props.waiting.handleClose();
		}
		
	}

	openDetails(e, id){
		e.preventDefault();
		var name = this.state.lastname1+' '+this.state.lastname2+' '+this.state.names;
		var g_rh = this.concatGroupRH();
		var birth = this.state.birthday;

		this.modal_details.handleShow(id, name, g_rh, birth);
	}

  	render() {
	    const { t } = this.props;
	    var session = sessionStorage.getItem('health_facilities_name');
	    
	    return (
	    	<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
					    {sessionStorage.getItem('health_facilities_name')} ->
						Inicio ->
						Donantes -> 
						Buscar Donador
					</h5>
				</div>
				<Help 
						{...this.props}
		                menu={"help_donors"} 
		                submenu={"help_search_donor"}  />

				<div className="col-xs-12 form-group">
					<div className="col-xs-7">
				 			<span className="span-min">{t('content.generics.buttons.search')}</span>
					        <AsyncTypeahead
					          labelKey={(option) => `${option.names}`}
					          minLength={3}
					          maxLength={50}
					          name="patient"
					          id="patient"
					          onSearch={this._handleSearchDonor}
					          placeholder="Buscar por apellidos más nombre o número de documento"
					          options={this.state.optionsDonor}
					          onChange={this.updateStateDonor}
					          ref="_handleSearchDonor"
					          useCache={false}
					          isLoading={this.state.isLoading}
					          delay={600}
					          paginationText="Mostrar mas resultados..."
					        />
				 			
					</div>

					<div className="col-xs-12 col-sm-1" style={{textAlign:'center', marginTop:'18px'}}>
						<SvgIcon icon={search} size={20} style={{cursor:'pointer'}} 
							onClick={this.person_search}/>
					</div>

				</div>
				
				<fieldset className="col-xs-12 form-group">
					<legend>Datos Generales</legend>
					<div className="col-xs-9">
						<div className="col-xs-12">
							<div className="row">
								<div className="col-xs-12"><SvgIcon size={25} icon={user}/></div>
								{this.state.edit ?
									<div className="col-xs-12">
										<input className="form-check-input" type="checkbox" name="dataEdition" 
							        		value={ this.state.dataEdition} onChange={ this.handleChange } 
							        		style={{marginRight:'5px'}}/>
							        	<span className="span-min">Editar Datos</span>
								    </div>
				    			:null}
								<div className="col-xs-12 col-sm-4">
									<span className="span-min">Nombre(s)</span>
									<input disabled={!this.state.dataEdition} type="text" className="form-control" value={this.state.names} name="names"
										id="names" onChange={this.handleChange} />
								</div>
								<div className="col-xs-12 col-sm-2">
									<span className="span-min">A. Paterno</span>
									<input disabled={!this.state.dataEdition} type="text" className="form-control" value={this.state.lastname1} name="lastname1"
										id="lastname1" onChange={this.handleChange} />
								</div>
								<div className="col-xs-12 col-sm-2">
									<span className="span-min">A. Materno</span>
									<input disabled={!this.state.dataEdition} type="text" className="form-control" value={this.state.lastname2} name="lastname2"
										id="lastname2" onChange={this.handleChange} />
								</div>

								<div className="col-xs-12 col-sm-4" >
							        <span className="span-min">{t('content.offers.form.email')} </span>
							        <span className="span-min" style={{color:'red'}}>{this.state.error_email}</span>
					            	<input disabled={!this.state.dataEdition} className="form-control" id="email" name="email" 
					            		placeholder="nombre@example.com"
					            		value={this.state.email || ""} onChange={this.handleChange} />
								</div>
							</div>
							<div className="row">
								<div className="col-xs-12 col-sm-2">
									<span className="span-min">{t('content.offers.form.document_type')}</span>
								
						            <select disabled={!this.state.dataEdition} className="form-control" name="document_type" id="document_type" 
						            	value={this.state.document_type} onChange={this.handleChange} >
						            	<option value="">Seleccionar...</option>
								        {this.state.documents.map((t) => (
						                  <option key={t.id}  value={t.key} >{t.name} </option>
						                ))}  
					              	</select>
								</div>

								<div className="col-xs-12 col-sm-2">
									<span className="span-min">Número</span>
									<input disabled={!this.state.dataEdition} type="text" className="form-control" value={this.state.document_number} name="document_number"
										id="document_number" onChange={this.handleChange} />
								</div>

								<div className="col-xs-12 col-sm-2">
									<span className="span-min">Género</span>
									<select className="form-control" id="sex"  name="sex" value={ this.state.sex } 
							        	onChange={ this.handleChange } disabled={!this.state.dataEdition}> 
							        	<option value="">Seleccionar...</option>
							        	<option value="HOMBRE">HOMBRE</option>
							        	<option value="MUJER">MUJER</option>
					                
				              		</select>
								</div>

								<div className="col-xs-12 col-sm-2">
									<span className="span-min">E. Civil</span>
									 <select disabled={!this.state.dataEdition} className="form-control" name="civil_status" id="civil_status" 
									 	value={ this.state.civil_status || ""} onChange={this.handleChange} > 
								        <option value="">Seleccionar...</option>
						                {this.state.civil_status_array.map((t)=>(
							                  <option key={t.id}  value={t.key} >{t.name} </option>
							            ))}
					              	</select>
								</div>									

								<div className="col-xs-12 col-sm-2">
									<span className="span-min">F. Nacimiento</span>
									<MaskedFormControl type='text' name="birthday" id="birthday" value={this.state.birthday} 
										onChange={this.handleChange} mask='11/11/1111' placeholder="dd/mm/yyyy"
										className="input-date"
										style={{padding:'3px 6px'}} disabled={!this.state.dataEdition}/>
									
								</div>

								<div className="col-xs-12 col-sm-2">
									<span className="span-min">Edad</span>
									<input disabled type="text" className="form-control" value={this.state.age} 
										onChange={(e)=>e.preventDefault()} />
								</div>

							</div>
							<div className="row">
								<div className="col-xs-12 col-sm-4" >
							        <span className="span-min">{t('content.offers.form.scholarship')} </span>
					            	<select disabled={!this.state.dataEdition} className="form-control" name="scholarship" id="scholarship"
							        	value={ this.state.scholarship ||""} onChange={this.handleChange}>
							        	<option value="" >Seleccionar...</option>
						                {this.state.scholarships.map((t) =>(
						                  	<option  key={t.id}  value={t.key} >{t.name}</option>
						               	))}
						            </select>
								</div>

								<div className="col-xs-12 col-sm-4" >
						        	<span className="span-min">{t('content.offers.form.job_profile')}</span>
					              	<Typeahead 
								        labelKey={(option) => `${option.name}`}
								        minLength={0}
								        id="job_profile" name="job_profile"
								        options={this.state.jobProfiles}
								        selected={this.state.requestedSelected}
								        onChange={this.handleTypeAheadChange('job_profile')}
								        onSearch={this._handleSearchJob}
								        ref="_handleSearch_job"
								        useCache={false}	
								        isLoading={this.state.isLoading}
								        disabled={!this.state.dataEdition}
								        delay={600}
								    />
								</div>
							</div>
							<div className="row">
								<div className="col-xs-8"><SvgIcon size={25} icon={home}/></div>
								<div className="col-xs-4"><SvgIcon size={25} icon={phone}/></div>
								<div className="col-xs-8" style={{padding:'0'}}>
									
									<div className="col-xs-12 col-sm-6">
										<span className="span-min">Calle y Número</span>
										<input disabled={!this.state.dataEdition} type="text" className="form-control" value={this.state.street} name="street"
											id="street" onChange={this.handleChange} />
									</div>

									<div className="col-xs-12 col-sm-6">
										<span className="span-min">Municipio</span>
										<AsyncTypeahead
								          labelKey={(option) => `${option.names}`}
								          name="mpio"
								          id="mpio" 
								          options={this.state.options}
								          onChange={this.updateState.bind(this.state.indice_mpio)}
								          onSearch={this.setMpio}
								          selected={this.state.mpioSelected}
								          ref="_handleSearch"
								          useCache={false}
								          isLoading={this.state.isLoading}
								          disabled={!this.state.dataEdition}
								          delay={600}
								          paginationText="Mostrar mas resultados..."
								        />
									</div>

									<div className="col-xs-12 col-sm-6">
										<span className="span-min">Estado</span>
										<select disabled={!this.state.dataEdition} className="form-control" name="state" id="state"
								        	value={ this.state.state || ""} onChange={this.handleChange} >
								        	<option value=""></option>
							                {this.state.states.map((s)=>(
						                  		<option key={s.id} 
						                  			value={this.state.state === s.key ?
						                  				s.key
						                  			: s.key.toUpperCase()}>
						                  				{s.value_name}
						                  		</option>
							                ))}
							            </select>
									</div>

									<div className="col-xs-12 col-sm-3">
										<span className="span-min">CP</span>
										<input disabled={!this.state.dataEdition} type="text" className="form-control" value={this.state.postal_code} name="postal_code"
											id="postal_code" onChange={this.handleChange} />
									</div>
								</div>
								<div className="col-xs-4" style={{padding:'0'}}>
									{this.state.phonesAdded.map((p, i)=>(
										<div key={i} className="col-xs-12" style={{marginTop:'20px'}}>
											<div className="input-group">
												<div className="input-group-addon" style={{padding:'3px 6px'}}>{p.type}</div>
	      										<input disabled={!this.state.dataEdition} type="text" className="form-control" value={p.number} 
	      											onChange={(e)=>this.phoneChange(e, i)} />
	  										</div>
										</div>
									))}
										
								</div>
							</div>
							
						</div>
					</div>

					<div className="col-xs-3">
						<div className="col-xs-12" style={{textAlign:'center'}}>	
							{this.state.stats.lookup_group!=="" && this.state.stats.lookup_group !== null?
								<h2 style={{color:"red", margin:'5px', fontSize:'4em'}}>
									{this.concatGroupRH()}
								</h2>
							:null}
						</div>

						{(this.state.stats.lectina !== "" && this.state.stats.lectina !== null && this.state.stats.lectina !== undefined) &&
							<div className="col-xs-12" style={{textAlign:'center'}}>
								<h4>Subgrupo <span style={{color:'#ff0000', fontWeight:'bold'}}>{this.state.stats.lectina}</span></h4>
							</div>
						}
					
						<div className="col-xs-12">
							{this.state.fenotipo_donante!==""?<div>
								<span className="span-min">Fenotipos</span>
								<span style={{paddingLeft:"10px"}} className="theme-color">
									{this.state.fenotipo_donante}
								</span></div>
							:null}
						</div>
				
						<div className="col-xs-12">
							{this.state.fenotipo_donante!==""?<div>
								<span className="span-min">Anticuerpos</span>
								<span style={{paddingLeft:"10px", color:'red'}} className="theme-color">
									{this.state.antibody_donante}
								</span></div>
							:null}
						</div>
						<div className="col-xs-12 form-group">
							{(this.state.du !== "" && this.state.du !== null)?<div>
								<span className="span-min">DU</span>
								<span style={{paddingLeft:"10px", color:'red'}} className="theme-color">
									{this.state.du}
								</span></div>
							:null}
						</div>

						{<div className="col-xs-12" style={{textAlign:'center'}}>
							{this.state.stats.total_hc !== 0?
				        		<div className="status-bar" 
				        			style={{backgroundColor:this.state.stats.status_bar_color,
				        				marginBottom:"5px", textAlign:"center"}} >
					            	<label style={{color:"white",margin:"3px"}}>
					            		{this.state.stats.temporality}
					            	</label>
					            </div>
					        :null}
						</div>}
						
						<div className="col-xs-12" style={{textAlign:'center'}}>
							{this.state.photo !== "" ?
								<img style={{height:'180px',width:'168px',textAlign:"center"}} src={this.state.photo} alt="default"/>
							:<img style={{height:'180px',width:'168px',textAlign:"center"}} src="../../default_user.jpg" alt="USER"/>}

						</div>
						
					</div>
				</fieldset>

				<div className="col-xs-12" style={{textAlign:"center"}}>
					<button disabled={this.state.donor_id === ''} className="btn"
						style={this.state.flag_alert ?  {color:'red', background:'transparent'} :
							this.state.flag_notes ? {color:'green', background:'transparent'} : {color:'#b8b8b8', background:'transparent'}  }
						//style={this.state.donor_id === '' ? {cursor:'no-drop'}:{cursor:'pointer'}}
						onClick={(e) => this.openModalNotes(e)} title="Notas">
						<SvgIcon size={40} icon={pencilSquareO} />
						<div className="col-xs-12">
							<span>{t('toolbar.save_notes')}</span>
						</div>
					</button>

					<button disabled={this.state.donor_id === ''} className="btn"
						style={{background:'transparent'}}
						onClick={(e) => this.openGeneralTraceability(e)} title="Trazabilidad">
						<SvgIcon size={40} icon={history} />
						<div className="col-xs-12">
							<span>Trazabilidad</span>
						</div>
					</button>
				</div>

				<fieldset className="col-xs-12">
					<legend>Donaciones / Ofrecimientos</legend>
					<Table responsive hover>
						<thead>
							<tr>
								<th>Fecha</th>
								<th>Estatus</th>
								<th>Tipo Extracción</th>
								<th>Tipo Donación</th>
								<th>Paciente</th>
								<th>No. Unidad</th>
								<th>L. Colecta</th>
								<th>Médico</th>
								<th>Vista Rápida</th>
								<th>Trazabilidad</th>
								<th>Ficha</th>
								<th>HC</th>
								<th>Laboratorio</th>
							</tr>
						</thead>
						<tbody>
							{this.state.tbl_don.map((t, i)=>(
								<tr key={i}>
									<td>
										{moment(t.timestamp_date).format('DD/MM/YYYY')+' '}
										{moment(t.timestamp_hour, 'HH:mm:ss').format('HH:mm')}
									</td>
									<td>{t.status}</td>
									<td>
										<span>{t.extraction_type}</span>
										{t.status === 'APTO' ?
											<a href="#" style={{marginLeft:'5px'}}
												onClick={(e)=>
												this.openDefailsExtraction(
													e, 
													t.donation_id, 
													t.offers_id, 
													t.extraction_type
												)}>
												<SvgIcon size={25} icon={search} />
											</a>
										:null}
									</td>
									<td><span>{t.donation_type}</span></td>
									<td>
										{t.patient_id !== null?
											<a href="#" style={{marginLeft:'5px'}} 
												onClick={(e)=>this.openDefailsPatient(e, t.id)}>
												<SvgIcon size={25} icon={search} />
											</a>
										:null}
									</td>
									<td>
										{t.status === 'APTO' ?
											<a href="#" onClick={(e)=>this.openTraceability(e, t.unit_number)}>
												{t.unit_number}
											</a>
										: t.unit_number}
											
									</td>
									<td>{t.convoke_places}</td>
									<td>
										{t.medical_staff}
									</td>
									<td>
										<a onClick={(e)=>this.openDetails(e, t.id)} title="Vista Rápida"
											style={{cursor:'pointer'}}>
											<SvgIcon size={23} icon={eye} />
										</a>
									</td>
									<td>
										<a href="#" onClick={(e)=>this.userTraceability(e, t.id)}>
											<SvgIcon size={23} icon={history} style={{marginLeft:'5px'}}/>	
										</a>
									</td>
									<td>
										{t.is_reactive &&
											<a href="#" onClick={(e)=>this.print(e, t.donation_id)}>
												<SvgIcon size={23} icon={print} style={{marginLeft:'5px'}}/>	
											</a>
										}
									</td>
									<td>
										<a disabled={!this.props.task_clinic_history.read ?
															true
													: t.external ? true 
													: false} 
											onClick={t.external ? (e)=>e.preventDefault() : (e)=>this.openPDF(t)}
											title={t.external ? 'Unidad externa' : 'Historia clínica'} 
											style={!this.props.task_clinic_history.read ?
														{border:"0px", cursor:'no-drop'}
													: t.external ? {border:"0px", cursor:'no-drop'} 
													: {border:"0px"}}>
					                		<SvgIcon size={23} icon={filePdf} />
					                	</a>
									</td>
									<td>
										<a href="#"  disabled={t.samples_id === 0}
											style={this.props.task_results_donation.read ?
													t.samples_id !== 0 ?
														t.lab_status === 'REJECT' ?	{color:'red'} :
														t.status === 'APTO' ? {color:'green'} : 
														t.status === 'PENDIENTE'? {color:'red'} : 
														{color:'#b8b8b8', cursor:'no-drop'} 
													:  {color:'#b8b8b8', cursor:'no-drop'}
												: {color:'#b8b8b8', cursor:'no-drop'}}
											onClick={this.props.task_results_donation.read ?
													t.samples_id !== 0 ?
														(e)=>this.openResultsDon(e, t.samples_id, t.donation_id) 
													: (e)=>e.preventDefault()
												: (e)=>e.preventDefault()
											}>
											<SvgIcon disabled={t.samples_id !== 0} size={25} icon={search} style={{marginLeft:'5px'}}/>
										</a>
										
									</td>
									
								</tr>
							))}
						</tbody>
					</Table>
		        </fieldset>

		        <div className="col-xs-12" style={{textAlign:"center"}}>
					

					<button disabled={this.state.donor_id === ''} className="btn"
						onClick={(e) => this.printCarnetDocument(e)} title="Carnet">
						<SvgIcon size={40} icon={profile} />
						<div className="col-xs-12">
							<span>Carnet</span>
						</div>
					</button>
				</div>

		        <div className="col-xs-12" style={{textAlign:'center'}}>
	        		<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} 
	        			disabled={!this.state.dataEdition} onClick={this.onSave}  style={{margin:12}}/>
	        		{this.props.location.state !== undefined ? 
	        			<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} 
	        			onClick={this.onReturn}  style={{margin:12}}/>
	        		:null}
	        	</div>
		    	
		        <ModalDetailsExtraction {...this.props} onRef={ref => (this.modal_extraction = ref)} />
		        <ModalDetails {...this.props} onRef={ref => (this.modal_details = ref)} />
		        <ModalDetailPatient {...this.props} onRef={ref => (this.modal_patient = ref)} />
		        <ModalTraceability {...this.props} onRef={ref => (this.modal_traceability = ref)} />
		        <ModalUserTraceability {...this.props} onRef={ref => (this.modal_user_traceability = ref)} />
				<ModalGeneralTraceability {...this.props} onRef={ref => (this.modal_general_traceability = ref)} />
		        <ModalNotes {...this.props} onRef={ref => (this.modal_notes = ref)} 
		        	setTable={this.setTable} donor_id={this.state.donor_id} />
		        <Notifications />
		        <ModalPersonSearch {...this.props} waiting={this.props.waiting} updatePerson={this.updateStateDonor} onRef={ref => (this.modal_person_search = ref)} />
			</div>
	    );
  	}
}

export default translate('translations')(SearchDonor)